import { render, staticRenderFns } from "./DishesNew.vue?vue&type=template&id=349f21f6&"
import script from "./DishesNew.vue?vue&type=script&lang=js&"
export * from "./DishesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports